import { AboutStyled } from "../Style-components/About.Styled";

function About() {
  return (
    <AboutStyled className="ab-br">
      <p className="light pd-bt">//about</p>
      <p>
        Hi, there 🖐 I'm REETU RAJ I'm self-taught Full-stack Developer located
        in INDIA with a background in Mechanical Engineering. I enjoy building
        porduct from start to finish.
      </p>
    </AboutStyled>
  );
}

export default About;
